import { render } from "./IconPerson.vue?vue&type=template&id=6d832f16"
import script from "./IconPerson.vue?vue&type=script&lang=js"
export * from "./IconPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__